import React, { Component } from 'react';
import Vas from '../Vas';
import '../css/Tariffing.css';
import { LinkButton } from 'component-lib';

class ErrorOnline  extends Component {

    //#region Komponente
    constructor(props)
    {
        super(props);
        this.state = {};
        this.history = props.history;
    }

    render()
    {
        let text = Vas.Resources.Labels["ErrorOnline"];
        if(localStorage.getItem('Error')){
          text = localStorage.getItem('Error');
        }

        return (<div className="TariffingContainer" >
          <div 
            className={"tariffingform"} 
            style={{ textAlign:'left' }}>
            <br />
            <table>
              <thead>
                <tr>
                  <th colSpan={2}><h2>{Vas.Resources.Titles["Error"]}</h2></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontSize:'14px'}}>{text}</td>
                  </tr>
                <tr>
                  <td style={{ fontSize:'14px'}}>
                    <LinkButton 
                      Text={Vas.Resources.Labels["Back"]} 
                      Id={"LinkLogin"} 
                      OnClick={()=>{
                        if(localStorage.getItem('Error')){
                          localStorage.removeItem('Error');
                        }
                        this.history.goBack();
                      }} />
                  </td>
                </tr>
              </tbody>
            </table> 
            </div>
        </div>);
    }
}
export default ErrorOnline;
